import { Injectable, inject } from '@angular/core';
import { Settings } from '@app/app.settings';
import { TranslateService } from '@ngx-translate/core';
import { UserRepository } from '../state/user/user.repository';
import { slotcomStorageStrategy } from '../state/slotcom.storage';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly culturesToEs = ['ca-es', 'ca', 'eu-es', 'eu', 'gl-es', 'gl'];

  get userLanguage(): string {
    return this.userRepo.getCulture();
  }

  private readonly translateService = inject(TranslateService);
  private readonly userRepo = inject(UserRepository);

  async initUserLanguage(): Promise<string> {
    const storedUser = await slotcomStorageStrategy.getItem('user');
    const culture: string | null = storedUser?.culture ?? null;

    const browserLang = culture ?? (navigator.language || Settings.defaultLang);
    const userLang = this.getImplementedCulture(browserLang);

    this.translateService.setDefaultLang(userLang);
    this.translateService.use(userLang);

    return userLang;
  }

  private getImplementedCulture(name?: string): string {
    if (!name) return Settings.defaultLang;

    const lowerName = name.toLowerCase();

    if (Settings.appLanguages.some((c) => c.toLowerCase() === lowerName)) {
      return lowerName;
    }

    if (this.culturesToEs.some((c) => c.toLowerCase() === lowerName)) {
      return 'es';
    }

    const neutral = this.getNeutralCulture(lowerName);
    const match = Settings.appLanguages.find((c) => c.startsWith(neutral));

    return match ?? Settings.defaultLang;
  }

  private getNeutralCulture(name: string): string {
    return name.split(/[-_]/)[0];
  }
}
